import { autoinject, computedFrom } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { watch } from 'aurelia-watch-decorator';
import { WidgetController } from 'controls/as-widget-container';
import { City } from 'model/business-keywords';
import { AccommodationSegment } from 'model/forms/trip-details';
import { KeywordsService } from 'services/keywords-service';
import { LookupsService } from 'services/lookups-service';
import { WidgetBase } from 'support/base_classes/widget-base';
import { FormSettings } from 'support/shared_models/form-settings';
import { MAX_DATE } from 'support/settings';

@autoinject
export class AccommodationSegmentWidget extends WidgetBase<AccommodationSegment, WidgetController> {
  public today = new Date().toISOString().slice(0, 10);
  public maxDate = MAX_DATE.toISOString().slice(0, 10);

  constructor(private keywords: KeywordsService, private lookups: LookupsService, private formSettings: FormSettings) {
    super();
  }

  bind() {
    ValidationRules
      .ensureObject<AccommodationSegment>().required()
      .ensure(model => model.type).displayName('Accommodation type').required()
      .ensure(model => model.arrivalDate).displayName('Arrival date').required().satisfiesRule('minDate').satisfiesRule('maxDate')
      .ensure(model => model.departureDate).displayName('Departure date').required().satisfiesRule('minDate').satisfiesRule('maxDate')
      .ensure(model => model.name).displayName('Name').required()
      .ensure(model => model.address).displayName('Address').required()
      .ensure(model => model.cityName).displayName('City').required()
      .ensure(model => model.country).displayName('Country').required()
      .on(this.model);
  }

  @computedFrom('model.type.formIcon')
  get widgetIcon() {
    return this.model.type?.formIcon || 'fas fa-bed';
  }

  @computedFrom('keywords.accommodationTypes', 'model.type')
  get accommodationTypes() {
    return this.keywords.ensureItem(this.keywords.getAccommodationTypes(this.formSettings.formType), this.model.type);
  }

  @computedFrom('keywords.countries', 'model.country')
  get countries() {
    return this.keywords.ensureItem(this.keywords.countries, this.model.country);
  }

  keywordsItemMatcher = this.keywords.itemsMatch;
  citiesLookupOptions = this.lookups.getCitiesLookupOptions();

  @watch((x: AccommodationSegmentWidget) => x.model.city)
  private cityChanged(newValue: City, oldValue: City) {
    if (this.model.country == null || this.model.country.id === oldValue?.country.id)
      this.model.country = newValue?.country ?? null;
  }
}
